import { render } from "./index.vue?vue&type=template&id=bb1830b8&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"

import "./index.vue?vue&type=style&index=0&id=bb1830b8&scoped=true&lang=css"

import exportComponent from "/Users/khatanbaatarb/Documents/projects/roadpay.mn/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-bb1830b8"]])

export default __exports__